import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";

function AgentPerHead() {
  return (
    <Crud
      title="Agent per head"
      getUrl={() => "/Agent/AgentPerHead_GetList"}
      // INSERT
      insertUrl={() => "/Agent/AgentPerHead_Insert"}
      insertParams={(
        { userId },
        { description, splitLocalOnline, splitComm }
      ) => ({
        Description: description,
        SplitLocalOnline: splitLocalOnline,
        SplitComm: splitComm,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Agent/AgentPerHead_Update"}
      updateParams={(
        { userId },
        { idAgentPerHead, description, splitLocalOnline, splitComm }
      ) => ({
        IdAgentPerHead: idAgentPerHead,
        Description: description,
        SplitLocalOnline: splitLocalOnline,
        SplitComm: splitComm,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Agent/AgentPerHead_Delete"}
      deleteParams={({ userId }, id) => ({
        IdAgentPerHead: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idAgentPerHead"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Description
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataFormat={moveFormatter}
        editable={{
          type: "checkbox",
          options: {
            values: "true:false",
          },
        }}
        dataField="splitLocalOnline"
      >
        Split Local / Online
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataFormat={moveFormatter}
        editable={{
          type: "checkbox",
          options: {
            values: "true:false",
          },
        }}
        dataField="splitComm"
      >
        Split Comission
      </TableHeaderColumn>
      <TableHeaderColumn dataField="detailCnt" hiddenOnInsert>
        Detail Cnt
      </TableHeaderColumn>
    </Crud>
  );
}

export default AgentPerHead;
